import { useKindeFeatureFlags, useTranslation } from "@next-platform/client-common-core";
import { IconVariants } from "@next-platform/client-common-spicy-ui";

import Dropdown from "../common/Dropdown";
import { DataSourceDropdownProps, DataSourceType } from "./types";

export default function DataSourceDropdown({ currentSource, onSourceChange, showDropdown }: DataSourceDropdownProps) {
  const { hasAccessToV2 } = useKindeFeatureFlags();
  const { t } = useTranslation();

  if (!showDropdown) {
    return null;
  }

  const sourceOptions = [
    {
      value: DataSourceType.MY_CHATBOTS,
      label: t("search:botContext.myChatbots"),
      onPress: () => onSourceChange(DataSourceType.MY_CHATBOTS),
    },
    {
      value: DataSourceType.FAVOURITES,
      label: t("search:botContext.favorites"),
      onPress: () => onSourceChange(DataSourceType.FAVOURITES),
    },
    {
      value: DataSourceType.SHARED_CHATBOTS,
      label: t("search:botContext.discover"),
      onPress: () => onSourceChange(DataSourceType.SHARED_CHATBOTS),
    },
  ];

  const getCurrentLabel = () => {
    const option = sourceOptions.find((opt) => opt.value === currentSource);
    return option?.label ?? t("search:botContext.myChatbots");
  };

  return <Dropdown currentValue={getCurrentLabel()} listItems={sourceOptions} hasAccessToV2={hasAccessToV2} iconEnd={IconVariants.CHEVRON_DOWN} />;
}
